import { Button, Form, Select, message, notification } from "antd";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import axios from "../../../config/axiosInstance";
import { API } from "../../../config/API";
import TextArea from "antd/es/input/TextArea";
import PageHeader from "../../../component/pageHeaders";
import { useNavigate } from "react-router-dom";
import { GET } from "../../../utils/apirequest";
import { useSelector } from "react-redux";
import { LoadTags } from "../../../utils/commonapis";
import ImageItem from "../../../component/imageItem";
import ImagePicker from "../../../component/imagePicker";
function NjayarForm(props: any) {
  const navigate = useNavigate();
  const User = useSelector((state: any) => state.User.user);
  const [loading, setLoading] = useState(false);
  const [tags, setTags] = useState<any>([]);
  const [tagFilter, setTagFilters] = useState("");
  const [loading3, setLoading3] = useState(true);

  const [form] = Form.useForm();
   const [imageuploaddata, setImageuploaddata] = useState<any>({
    imageurl1: "",
  });
  const [uploadImg, setUploadImg] = useState(false);
  const [imageType, setImageType] = useState("");
  const [imageName, setImageName] = useState("");

  useEffect(() => {
    loadTags(tagFilter);
  }, [tagFilter]);

  const loadTags = async (searchTerm: any) => {
    setLoading3(true);
    try {
      const res: any = await LoadTags(searchTerm);
      setTags(res);
    } catch (error) {
    } finally {
      setLoading3(false);
    }
  };
   function deleteImagesFromList(key: any) {
    try {
      setImageuploaddata((prevImages: any) => {
        const updatedImages = { ...prevImages };
        updatedImages[key] = "";
        return updatedImages;
      });
      notification.success({
        message: `Image Removed`,
      });
    } catch (err) {
      notification.error({
        message: `Failed to remove`,
      });
    }
  }

 const addImagesToList = (data: any) => {
    try {
      let DataObj = { ...imageuploaddata }; 
      if (data.type === "image1") {
        DataObj["imageurl1"] = data.image_url;
        DataObj["image1Value"] = data.image_desc;
        DataObj["image1Caption"] = data.image_Caption;
      }
      setImageuploaddata(DataObj);
      setUploadImg(false);
      notification.success({
        message: `Image uploaded successfully`,
      });
    } catch (err) {
      console.log(err);
      notification.error({
        message: `Failed to upload image`,
      });
    }
  }

  function debounce(func: any, delay: any) {
    let timer: any;
    return (...args: any) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  }

  const OnTagSearch = debounce((value: any) => {
    setTagFilters(value);
  }, 200);

  const onFinish = async (values: any) => {
    setLoading(true);
    let requestObj = {
      data: {
        head: values?.title,
        permalink: values?.permalink,
        tags: values.tags,
        user: User?.id,
        thumbnail: imageuploaddata.imageurl1,
      },
    };
    let url = API.BASE_URL + API.NJAYAR_MASTER;
    let method = "POST";
    axios({
      method: method,
      url: url,
      data: requestObj,
    })
      .then((response) => {
        setLoading(false);
        message.success(
          <>
            Success : <b>Saved</b>
          </>
        );
        navigate(
          `/Auth/NjayarScreen/njayarArticles/${response?.data?.data?.id}`,
          { state: { items: response?.data?.data } }
        );
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const formItemLayout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 20 },
  };

  return (
    <div>
      <PageHeader title={"Njayar prabhaatham"} />
      <div style={{ border: "1px solid #f0f2f5" }}> </div>
      <Col md={{ span: 11, offset: 1 }} style={{ marginTop: 50 }}>
        <Form onFinish={onFinish} form={form} name="add-editorials">
          <Row>
            <Col md={6}>
              <label className="newsFormLabels">Title</label>
              <Form.Item name="title" {...formItemLayout}>
                <TextArea />
              </Form.Item>
            </Col>
            <Col md={6}>
              <div className="newsFormLabels">Tags</div>
              <Form.Item name="tags" {...formItemLayout}>
                <Select
                  mode="multiple"
                  filterOption={(input: any, option: any) =>
                    option?.children
                      ?.toLowerCase()
                      ?.indexOf(input.toLowerCase()) >= 0
                  }
                  loading={loading3}
                  onSearch={(val) => OnTagSearch(val)}
                >
                  {tags.length > 0 &&
                    tags.map((item: any, index: any) => (
                      <Select.Option key={item.id} value={item.id}>
                        {item.tag}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col md={6}>
              <label className="newsFormLabels">permalink</label>
              <Form.Item name="permalink" {...formItemLayout}>
                <TextArea />
              </Form.Item>
            </Col>
           
             <Col md={6}>
              <div className="newsFormLabels">Thumbnail</div>
              <ImageItem
                imageurl={imageuploaddata?.imageurl1}
                upload={() => {
                  if (imageuploaddata?.imageurl1 === "") {
                    setImageType("image1");
                    setImageName("Main Image");
                    setUploadImg(true);
                    console.log("Opening image picker...");
                  }
                }}
                delete={() => deleteImagesFromList("imageurl1")}
              />
            </Col>
             <Col md={6}></Col>
            <Col md={6} style={{ marginTop: "40px",marginBottom: "20px" }}>
              <div className="epaper-uploads"  style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  className="epaper-Btn"
                  htmlType="submit"
                  loading={loading}
                  type="primary"
                >
                  create articles
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Col>
     
      <ImagePicker
        mode="create"                             
        imageType={imageType}
        imageName={imageName}
        onSubmit={(val: any) => addImagesToList(val)}
        visible={uploadImg}                  
        close={() => setUploadImg(false)}    
      />
    </div>
  );
}

export default NjayarForm;
